export default "__VITE_ASSET__0082d193__"